import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { Box, Typography, Chip, IconButton, Stack } from '@mui/material';
import { sxConfig } from './materialTransport.style';
import dayjs from 'dayjs';

const MaterialTransportCard = ({
  row,
  getOperationData,
  isSelected,
  handleSelect,
  handleDelete,
  dragProvided,
  deleteDisabled,
}) => {
  const { findedOperation, operationColor } = getOperationData(row.operation);

  const companyAddress = row.company.companyAdress?.[0];
  const address = [companyAddress?.postCode, companyAddress?.city, companyAddress?.streetAddress]
    .filter(Boolean)
    .join(', ');

  return (
    <Box
      ref={dragProvided.innerRef}
      {...dragProvided.draggableProps}
      style={dragProvided.draggableProps.style}
      sx={sxConfig.transportCard(isSelected, row.completed)}
      onClick={handleSelect}
    >
      <Stack direction="row" alignItems="center" spacing={1} flex={1} minWidth={0} {...dragProvided.dragHandleProps}>
        <DragIndicatorIcon sx={sxConfig.dragIcon} />

        <Stack direction="row" alignItems="center" spacing={2} flex={1} minWidth={0}>
          <Typography fontSize={16} fontWeight={600} flexShrink={0}>
            {row.visOrder}
          </Typography>

          <Stack flex={1} minWidth={0}>
            <Typography fontWeight={600} noWrap>
              {row.company.name}
            </Typography>

            {address && (
              <Typography fontSize={13} noWrap mt={0.5} color="text.secondary">
                {address}
              </Typography>
            )}

            <Stack direction="row" alignItems="center" spacing={0.75}>
              <CalendarTodayOutlinedIcon
                sx={{
                  fontSize: 14,
                  color: 'text.secondary',
                }}
              />
              <Typography fontSize={13} color="text.secondary" noWrap pt={0.2}>
                {dayjs(row.plannedDate).format('YYYY.MM.DD.')}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Chip
          label={findedOperation?.label}
          sx={{
            ...sxConfig.operationChip(operationColor),
            flexShrink: 0,
            maxWidth: { xs: 100, sm: 'none' },
            '& .MuiChip-label': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
        />
      </Stack>
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          handleDelete(row.id);
        }}
        sx={sxConfig.deleteButton}
        disabled={deleteDisabled}
      >
        <DeleteOutlineIcon sx={sxConfig.deleteIcon} />
      </IconButton>
    </Box>
  );
};

export default MaterialTransportCard;
